import { useLocation } from 'react-router-dom';

import { useSignupParams } from './useSignupParams';

export const useCurrentStep = () => {
  const { rawAffiliateParam } = useSignupParams();
  const location = useLocation();

  const currentStep = location.pathname
    .replace(`${rawAffiliateParam}`, '')
    .replace(/\//g, '');

  return currentStep;
};
